export const messageWithApp = (param: any) => {
  try {
    // @ts-ignore
    if (!window.bridgeSend) {
      // @ts-ignore
      window.bridgeSend = function (data) {
        // @ts-ignore
        if (
          // @ts-ignore
          window.flutter_inappwebview &&
          // @ts-ignore
          window.flutter_inappwebview.callHandler
        ) {
          // @ts-ignore
          window.flutter_inappwebview.callHandler(
            "FlutterChannel1",
            JSON.stringify(data)
          );
        }
      };
    }
    setTimeout(() => {
      // @ts-ignore
      window.bridgeSend(param);
    }, 400);
  } catch (e) {
    console.error("messageWithApp: ", e);
  }
};
